import type { UseFormReturn } from 'react-hook-form';

import {
  OTDetalleInstallTecnicoFormTab,
  OTInstalacionTecnicoFormTab,
} from '@/erp/tecnico/orden-trabajo/shared/components';
import { a11yProps, tabTextLabelSx, useTabsFormOnly } from '@/shared';
import {
  CustomTabPanel,
  FormTabsOnly,
  NestedTabsScene,
  TabTextLabel,
} from '@/shared/components/ui';
import type { Contrato } from '@/shared/interfaces';
import { Tab } from '@mui/material';
import type { ClienteFibraSummaryFormType } from '../SaveContractFibra';

export type ClienteFibraOTServicePartProps = {
  contract: Contrato;
  form: UseFormReturn<ClienteFibraSummaryFormType>;
};

const ClienteFibraOTServicePart: React.FC<ClienteFibraOTServicePartProps> = ({
  contract,
  form,
}) => {
  ///* hooks -------------------------
  const { handleMethodChange, valueTab } = useTabsFormOnly({
    initialTabValue: 1,
  });

  ///* form -------------------------
  const { errors } = form.formState;

  return (
    <>
      <TabTextLabel
        text="Detalles de Instalación"
        sx={{
          ...tabTextLabelSx,
          pb: '3px',
          pt: '54px',
          mt: '0px',
        }}
      />

      <NestedTabsScene
        tabs={
          <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
            <Tab label="ORDEN TRABAJO" value={1} {...a11yProps(1)} />
            <Tab label="DETALLE INSTALACIÓN" value={2} {...a11yProps(2)} />
          </FormTabsOnly>
        }
      >
        {/* ===================== ORDEN TRABAJO ===================== */}
        <CustomTabPanel index={valueTab} value={1}>
          <OTInstalacionTecnicoFormTab
            form={form}
            errors={errors}
            shrink={true}
            viewContratos={true}
          />
        </CustomTabPanel>

        {/* ===================== DETALLES DE INSTALACIÓN ===================== */}
        <CustomTabPanel index={valueTab} value={2}>
          <OTDetalleInstallTecnicoFormTab
            form={form as any}
            errors={errors}
            shrink={true}
            coords={contract.orden_trabajo_data?.coordenadas || ''}
            ordenTrabajo={contract.orden_trabajo_data!}
            isOnlyView
          />
        </CustomTabPanel>
      </NestedTabsScene>
    </>
  );
};

export default ClienteFibraOTServicePart;
